// src/backend/providers/cineverse.ts

import { Stream } from "@p-stream/providers";

// Your secure backend API endpoint
const API_ENDPOINT = "https://8ball.piracy.cloud/api/generate-secure-url";

/**
 * Fetches a secure, signed Bunny CDN URL from your backend.
 * This will be the high-priority source for p-streamer.
 */
export async function getCineverseStream(
  tmdbId: string,
  type: "movie" | "tv",
  season?: { number: number; tmdbId: string },
  episode?: { number: number; tmdbId: string },
): Promise<Stream | null> {
  let filePath = "";
  if (type === "movie") {
    filePath = `/media/${tmdbId}/master.m3u8`;
  } else if (type === "tv" && season && episode) {
    filePath = `/media/${tmdbId}-${season.number}-${episode.number}/master.m3u8`;
  } else {
    // We won't log an error here to avoid console noise,
    // it will just return null and fallback gracefully.
    return null;
  }

  try {
    const response = await fetch(API_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ filePath }),
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    if (!data.secureUrl) {
      return null;
    }

    // Return a stream object that matches the required format
    return {
      id: "cineverse",
      flags: [], // FIX: The value is correct, but we removed the unused StreamFlags import.
      playlist: data.secureUrl,
      type: "hls",
      headers: {
        Referer: "https://8ball.piracy.cloud/",
      },
      captions: [],
    };
  } catch (error) {
    // In production, it's better to let it fail silently and fall back.
    // console.error("[Cineverse] Error fetching secure URL:", error);
    return null;
  }
}
